"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorCalendarController = /** @class */ (function () {
    function InstructorCalendarController($rootScope, CalendarModel, UserService, DrivesFilterService, CalendarService, $state) {
        var _this = this;
        this.entities = [];
        this.$rootScope = $rootScope;
        this.CalendarModel = CalendarModel;
        this.UserService = UserService;
        this.CalendarService = CalendarService;
        this.DrivesFilterService = DrivesFilterService;
        this.$state = $state;
        this.updateEntities = this.updateEntities.bind(this);
        this.handleAgendaClick = this.handleAgendaClick.bind(this);
        // check cal service for view
        if (!this.CalendarService.getCalendarView()) {
            this.CalendarService.setCalendarView("dayGridMonth");
        }
        this.loading = false;
        $rootScope.$on("UPDATE_CALENDAR", this.updateEntities);
        $rootScope.$on("CALENDAR_LOADING", function () {
            _this.loading = true;
        });
    }
    InstructorCalendarController.prototype.updateEntities = function () {
        var entities = this.CalendarService.getCalendarItems();
        this.entities = entities;
        this.loading = false;
    };
    InstructorCalendarController.prototype.handleAgendaClick = function (data) {
        this.$state.go("drivecoach.instructor.dashboard.agenda", {
            date: data.dateStr,
        });
    };
    return InstructorCalendarController;
}());
InstructorCalendarController.$inject = [
    "$rootScope",
    "CalendarModel",
    "UserService",
    "DrivesFilterService",
    "CalendarService",
    "$state",
];
exports.default = InstructorCalendarController;
